import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/jwt.service";
import router from '@/router';

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        let token = JwtService.getToken()
        if (token) {
            Vue.axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${JwtService.getToken()}`;
        }
    },

    /**
     * Set the default HTTP request headers
     */
    setHeader() {
        Vue.axios.defaults.headers.common[
            "Authorization"
            ] = `Bearer ${JwtService.getToken()}`;
    },

    download(resource, params) {
        this.setHeader();
        Vue.axios.defaults.headers.common[
            "responseType"
            ] = `blod`;
        return new Promise(resolve => {
            Vue.axios.get(`${resource}`, {params}).then((data) => {
                this.handleResponse(data);
                resolve(data);
            })
                .catch((error) => {
                    this.handleResponseError(error);
                });
        });
    },

    query(resource, params) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.get(`${resource}`, {params}).then((data) => {
                this.handleResponse(data);
                resolve(data);
            })
                .catch((error) => {
                    this.handleResponseError(error);
                });
        });
    },

    /**
     * Send the GET HTTP request
     * @param resource
     * @param slug
     * @returns {*}
     */
    get(resource, slug = "") {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.get(`${resource}/${slug}`).then((data) => {
                this.handleResponse(data);
                resolve(data);
            }).catch(error => {
                this.handleResponseError(error);
            });
        });
    },

    /**
     * Set the POST HTTP request
     * @param resource
     * @param params
     * @returns {*}
     */
    post(resource, params, config = null) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.post(`${resource}`, params, config).then((data) => {
                this.handleResponse(data);
                resolve(data);
            }, {responseType: 'blod'}).catch(error => {
                this.handleResponseError(error);
            });
        });
    },

    /**
     * Send the UPDATE HTTP request
     * @param resource
     * @param slug
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    update(resource, slug, params) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.put(`${resource}/${slug}`, params).then((data) => {
                this.handleResponse(data);
                resolve(data);
            }).catch(error => {
                this.handleResponseError(error);
            });
        });
    },
        /**
     * Send the UPDATE HTTP request
     * @param resource
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
         update1(resource,  params) {
            this.setHeader();
            return new Promise(resolve => {
                Vue.axios.put(`${resource}`, params).then((data) => {
                    this.handleResponse(data);
                    resolve(data);
                }).catch(error => {
                    this.handleResponseError(error);
                });
            });
        },

    /**
     * Send the PUT HTTP request
     * @param resource
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    put(resource, params) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.put(`${resource}`, params).then(({data}) => {
                this.handleResponse(data);
                resolve(data)
            }).catch(error => {
                this.handleResponseError(error);
            });
        });
    },

    /**
     * Send the DELETE HTTP request
     * @param resource
     * @returns {*}
     */
    delete(resource, param) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.delete(`${resource}/${param}`).then(({data}) => {
                this.handleResponse(data);
                resolve(data);
            }).catch(error => {
                this.handleResponseError(error);
            });
        });
    },


    patch(resource, params) {
        this.setHeader();
        return new Promise(resolve => {
            Vue.axios.patch(`${resource}`, params).then(({data}) => {
                this.handleResponse(data);
                resolve(data);
            }).catch(error => {
                this.handleResponseError(error);
            });
        });
    },

    handleResponse(data) {
        // cần xóa token đi có 2 th là token hết hạn thì sẽ ko lỗi đấy
        if (data && data.data
            && !data.data.status && data.data.errorCode == 401) {
            JwtService.destroyToken();
            router.push({ name: "login" });
        }
    },

    handleResponseError(error) {
        // cần xóa token đi có 2 th là token hết hạn thì sẽ ko lỗi đấy
        if (error && error.response && error.response.status == 401) {
            JwtService.destroyToken();
            router.push({ name: "login" });
        }else{
            throw new Error(`[RWV] ApiService ${error}`);
        }
    }
};

export default ApiService;
